import moment from "moment";
import { Client } from "../../clients/client";
import { Order } from "./models/Order";
import { Category } from "./models/Category";
import { Item } from "./models/Item";
import {
  CreateOrderItemsRequestParams,
  CreateOrderItemRequestParams
} from "../../clients/OrderClient";
import { OrderItem } from "./models/OrderItem";
import { FixOrderFindOrderForms } from "./forms/FixOrderFindOrderForms";

export class FixOrderUseCase {
  constructor(private client: Client) {}

  public async getOrderInfo(form: FixOrderFindOrderForms): Promise<Order[]> {
    return this.client.orders.getOrderInfoByMcNumberForFixOrder(form.mcNumber);
  }

  public async getCategoriesByShopId(shopId: number): Promise<Category[]> {
    return this.client.categories.getCategoriesByShopId(shopId);
  }

  public async getItemByCategoryId(categoryId: number): Promise<Item[]> {
    return this.client.items.getItemByCategoryId(categoryId);
  }

  public async postOrderItems(order: Order, recoverOrderItems: OrderItem[]) {
    const items: CreateOrderItemRequestParams[] = recoverOrderItems.map(
      recoverOrderItem => {
        return {
          itemId: recoverOrderItem.item.id!,
          price: +recoverOrderItem.price!,
          amount: +recoverOrderItem.amount!,
          total: recoverOrderItem.total!
        };
      }
    );

    return this.client.orders.postOrderItems({
      orderId: order.id!,
      items
    });
  }
}
